<template>
  <div class="w-72 max-lg:bg-white max-lg:hidden max-lg:min-h-screen max-lg:px-8 max-lg:fixed max-lg:top-0 max-lg:left-0 max-lg:z-50" :class="{ 'max-lg:!block': filterState }">
    <div class="hidden mt-6 mb-10 max-lg:!flex max-lg:justify-between">
        <h2 class="text-xl font-bold">{{ $t('page.filter') }}</h2>
        <button @click="$emit('closeFilter', true)"
            class="absolute right-5 rounded p-1.5 bg-[#F8F8F8] hover:bg-[#F0F0F0] ease-linear transition-all duration-150">
            <IconClose></IconClose>
        </button>
    </div>
    <div class="divide-y-2 overflow-y-auto max-lg:h-[90vh]">
      <div v-if="!hideFilters.includes('currentCategory')">
        <p class="font-semibold text-xl mb-4">{{ $t("page.categories") }}</p>
        <div class="overflow-y-scroll fltrs">
          <ul class="space-y-3 row-list">
            <li>
              <router-link
                class="text-main-color text-base font-semibold hover:text-accent-color"
                :class="{ '!text-accent-color': currentCategory == null }"
                :to="{
                  name: routeName,
                  query: {
                    category: null,
                    subscription: currentSubscription,
                    is_vip: isVip,
                    ordering: currentSort,
                  location: location,

                  },
                }"
                >{{ $t("page.all") }}</router-link
              >
            </li>
            <li v-for="cat in categories" :key="cat.id">
              <router-link
                class="text-main-color text-base font-semibold hover:text-accent-color"
                :class="{ '!text-accent-color': cat.id == currentCategory }"
                :to="{
                  name: routeName,
                  query: {
                    category: cat.id,
                    subscription: currentSubscription,
                    is_vip: isVip,
                    ordering: currentSort,
                  location: location,

                  },
                }"
                >{{ cat.name }}
                <span class="text-red-400 text-sm"
                  >({{ cat.objects__count }})</span
                ></router-link
              >
            </li>
          </ul>
        </div>
      </div>
      <div v-if="!hideFilters.includes('currentSubscription')" class="my-5 py-5">
        <p class="font-semibold text-xl mb-4">{{ $t("page.status") }}</p>
        <div class="overflow-y-scroll fltrs">
          <ul class="space-y-3 row-list">
            <li>
              <router-link
                class="text-main-color text-base font-semibold hover:text-accent-color"
                :class="{ '!text-accent-color': currentSubscription == null }"
                :to="{
                  name: routeName,
                  query: {
                    category: currentCategory,
                    subscription: null,
                    is_vip: isVip,
                    ordering: currentSort,
                  location: location,

                  },
                }"
                >{{ $t("page.all") }}</router-link
              >
            </li>
            <li>
              <router-link
                class="text-main-color text-base font-semibold hover:text-accent-color"
                :class="{ '!text-accent-color': currentSubscription == 1 }"
                :to="{
                  name: routeName,
                  query: {
                    category: currentCategory,
                    subscription: 1,
                    is_vip: isVip,
                    ordering: currentSort,
                  location: location,

                  },
                }"
                >GOLD</router-link
              >
            </li>
            <li>
              <router-link
                class="text-main-color text-base font-semibold hover:text-accent-color"
                :class="{ '!text-accent-color': currentSubscription == 2 }"
                :to="{
                  name: routeName,
                  query: {
                    category: currentCategory,
                    subscription: 2,
                    is_vip: isVip,
                    ordering: currentSort,
                  location: location,

                  },
                }"
                >SILVER</router-link
              >
            </li>
            <li>
              <router-link
                class="text-main-color text-base font-semibold hover:text-accent-color"
                :class="{ '!text-accent-color': currentSubscription == 3 }"
                :to="{
                  name: routeName,
                  query: {
                    category: currentCategory,
                    subscription: 3,
                    is_vip: isVip,
                    ordering: currentSort,
                  location: location,

                  },
                }"
                >BRONZE</router-link
              >
            </li>
            <li v-if="!hideFilters.includes('isVip')">
              <router-link
                class="text-main-color text-base font-semibold hover:text-accent-color"
                :class="{ '!text-accent-color': isVip == 'true' }"
                :to="{
                  name: routeName,
                  query: {
                    category: currentCategory,
                      subscription: currentSubscription,
                    is_vip: isVip == 'true' ? null : true,
                    ordering: currentSort,
                  location: location,

                  },
                }"
                >VIP</router-link
              >
            </li>
          </ul>
        </div>
      </div>
     
      <div class="my-3 py-3">
          <button @click="clearFilter" class="bg-accent-color w-full py-2 rounded-md text-white hover:bg-main-color">{{ $t('page.clear') }}</button>
      </div>
    </div>
  </div>
  <div class="fixed inset-0 hidden bg-gray-800 bg-opacity-50 " :class="{ 'max-lg:!flex': filterState }"></div>

  </template>
  
  <script>
  import _debounce from "lodash.debounce";
  import IconClose from '@icons/IconClose.vue'
  export default {
    name: "MediaSide",
    components: {
      IconClose
    },
    props: {
      routeName: {
        type: String,
        default: "stores",
      },
      filterState: {
        type: Boolean,
        default: false
      },
      hideFilters: {
          type: Array,
          default: [],
          required: false
      },
      currentCategory: {
        type: [Number, String],
        default: undefined
      },
      currentSubscription: {
        type: [Number, String],
        default: undefined
      },
      isVip: {
        type: [Boolean, String],
        default: undefined
      },
  
      currentSort: {
        type: [Number, String],
        default: undefined
      },
      categories: {
        type: Array,
        default: []
      },
      location: {
        type: [Number, String],
        default: undefined,
      }
    },
    watch: {
      },
    data() {
      return {
     
      };
    },
    methods: {
      clearFilter(){
          this.$router.push({
              name: this.routeName,
              
        });
      },
   
    },
    mounted(){
      
    },
    computed: {
     
    },
  };
  </script>
  